export default "__VITE_ASSET__e4bcf825__"